export enum FORM_MODES {
  NEW = 'NEW',
  VIEW = 'VIEW',
  COPY = 'COPY',
  EDIT = 'EDIT',
  IMPORT = 'IMPORT',
  RESET = 'RESET',
}
